var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkLibraryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4842_43158)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.75736 22.2426C3.5147 24 6.34311 24 11.9999 24C17.6567 24 20.4852 24 22.2425 22.2426C23.9999 20.4852 23.9999 17.6567 23.9999 11.9999C23.9999 6.34311 23.9999 3.5147 22.2425 1.75736C20.4852 -1.4305e-07 17.6567 0 11.9999 0C6.34311 0 3.5147 -1.4305e-07 1.75736 1.75736C-1.4305e-07 3.5147 0 6.34319 0 12.0001C0 17.6568 -1.4305e-07 20.4852 1.75736 22.2426Z",
    fill: "#D0D3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95538 9.47705C6.93786 9.17304 6.9375 8.76515 6.9375 8.16908V0.0824875C8.32445 -1.3411e-07 9.997 0 12.0375 0C14.0779 0 15.7505 -1.3411e-07 17.1374 0.0824875V8.16908C17.1374 8.76515 17.1371 9.17304 17.1196 9.47705C17.1014 9.79207 17.0682 9.88891 17.0599 9.90751C16.8834 10.3051 16.4478 10.5194 16.0251 10.4168C16.0054 10.412 15.9083 10.3791 15.6477 10.2014C15.3961 10.0298 15.0727 9.78115 14.6004 9.41755L14.52 9.35559C14.0758 9.01308 13.7296 8.74617 13.3524 8.58231C12.5136 8.2179 11.5613 8.2179 10.7225 8.58231C10.3454 8.74617 9.99917 9.01308 9.55493 9.35559L9.47452 9.41755C9.00223 9.78115 8.67884 10.0298 8.42727 10.2014C8.16663 10.3791 8.0696 10.412 8.04984 10.4168C7.62715 10.5194 7.19155 10.3051 7.01498 9.90751C7.00673 9.88891 6.97354 9.79207 6.95538 9.47705Z",
    fill: "#7B86A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4842_43158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkLibraryIcon);
export default __webpack_public_path__ + "static/media/BookmarkLibraryIcon.8d59fc821ee4f0abbfadd9f8470ad0af.svg";
export { ForwardRef as ReactComponent };